import React, { useState } from 'react';
import { Phone, Mail, Send } from 'lucide-react';
export function Contact() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitted(true);
    }, 1000);
  };
  return <section id="contact" className="py-20 md:py-24 bg-brand-900 text-white relative overflow-hidden" data-id="element-53" data-mp="3sx8153x0bxgd">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-54" data-mp="3oy8u9drptqma">
        <div className="grid lg:grid-cols-2 gap-12" data-id="element-55" data-mp="3k3uwx5tht9ez">
          {/* Contact Info */}
          <div className="space-y-8" data-id="element-56" data-mp="3f59t6wf187ls">
            <div data-id="element-57" data-mp="3f48hcpq6zh30">
              <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4" data-id="element-58" data-mp="ggcjg2p77zup">
                Get a Free Case Evaluation
              </h2>
              <p className="text-brand-100 text-lg leading-relaxed" data-id="element-59" data-mp="bokx64d2sgad">
                Time is limited to file a claim in California. Contact the
                state's premier mesothelioma law firm today. We are available
                24/7 to discuss your case at no cost to you.
              </p>
            </div>

            <div className="space-y-6" data-id="element-60" data-mp="3b2rfc5yar305">
              <a href="tel:805-770-9317" className="flex items-center gap-4 group" data-id="element-61" data-mp="3f4mi7evvlog1">
                <div className="bg-brand-800 p-4 rounded-full group-hover:bg-brand-accent transition-colors" data-id="element-62" data-mp="3141woaykteiu">
                  <Phone className="w-6 h-6 text-white group-hover:text-brand-900 transition-colors" data-id="element-63" data-mp="364ze2lbri4ja" />
                </div>
                <div data-id="element-64" data-mp="2s6hvt34mlk8r">
                  <div className="text-sm text-brand-200 font-medium" data-id="element-65" data-mp="2w60h400czxc4">
                    Call Us 24/7
                  </div>
                  <div className="text-2xl font-bold text-white group-hover:text-brand-accent transition-colors" data-id="element-66" data-mp="qcseegfo5u71">
                    (805) 770-9317
                  </div>
                </div>
              </a>

              <div className="flex items-center gap-4" data-id="element-67" data-mp="23cn3gss9x5lc">
                <div className="bg-brand-800 p-4 rounded-full" data-id="element-68" data-mp="1ychbtcm07j39">
                  <Mail className="w-6 h-6 text-brand-accent" data-id="element-69" data-mp="1yb663790019i" />
                </div>
                <div data-id="element-70" data-mp="1ubp10exhh64v">
                  <div className="text-sm text-brand-200 font-medium" data-id="element-71" data-mp="1ud02u97dc3tc">
                    Email Us
                  </div>
                  <div className="text-lg font-bold text-white" data-id="element-72" data-mp="2m2244m41rsp7">
                    help@californiamesotheliomaclaims.com
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white rounded-2xl p-8 shadow-2xl text-slate-900" data-id="element-73" data-mp="2d8gol0k267eq">
            {submitted ? <div className="h-full flex flex-col items-center justify-center text-center space-y-4 py-12" data-id="element-74" data-mp="28a5eqptrjwwi">
                <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-4" data-id="element-75" data-mp="35rdqpe24gj9d">
                  <Send className="w-8 h-8" data-id="element-76" data-mp="38ah279drlz7w" />
                </div>
                <h3 className="text-2xl font-bold text-brand-900" data-id="element-77" data-mp="38cbnwpwv1vd1">
                  Request Received
                </h3>
                <p className="text-slate-600" data-id="element-78" data-mp="3dbere5x6ztiw">
                  Thank you for reaching out. A legal specialist will contact
                  you shortly to discuss your case.
                </p>
                <button onClick={() => setSubmitted(false)} className="mt-4 text-brand-600 font-medium hover:text-brand-800" data-id="element-79" data-mp="3m7x9so7srz18">
                  Submit another request
                </button>
              </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-80" data-mp="4ujy9i675ni0">
                <h3 className="text-2xl font-bold text-brand-900 mb-6" data-id="element-81" data-mp="9rtnawpobx5b">
                  Confidential Contact Form
                </h3>

                <div className="grid grid-cols-2 gap-4" data-id="element-82" data-mp="dsdku1e5t2rz">
                  <div className="space-y-2" data-id="element-83" data-mp="iukzwzuacyyj">
                    <label htmlFor="firstName" className="text-sm font-medium text-slate-700" data-id="element-84" data-mp="ir6x5qhpmnqk">
                      First Name *
                    </label>
                    <input required type="text" id="firstName" name="firstName" placeholder="Jane" autoComplete="off" className="w-full px-4 py-3 rounded-md border border-slate-300 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none transition-all" data-id="element-85" data-mp="ewckkit68wqm" />
                  </div>
                  <div className="space-y-2" data-id="element-86" data-mp="3s9fmm27rtzq8">
                    <label htmlFor="lastName" className="text-sm font-medium text-slate-700" data-id="element-87" data-mp="3nc61uzvbuc8q">
                      Last Name *
                    </label>
                    <input required type="text" id="lastName" name="lastName" placeholder="Doe" autoComplete="off" className="w-full px-4 py-3 rounded-md border border-slate-300 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none transition-all" data-id="element-88" data-mp="12lez3hsie9gw" />
                  </div>
                </div>

                <div className="space-y-2" data-id="element-89" data-mp="347ki46bv4evi">
                  <label htmlFor="phone" className="text-sm font-medium text-slate-700" data-id="element-90" data-mp="349x5x04axjgh">
                    Phone Number *
                  </label>
                  <input required type="tel" id="phone" name="phone" placeholder="(555) 123-4567" autoComplete="off" className="w-full px-4 py-3 rounded-md border border-slate-300 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none transition-all" data-id="element-91" data-mp="2ug6js1vndl3y" />
                </div>

                <div className="space-y-2" data-id="element-92" data-mp="py29hn2djju">
                  <label htmlFor="email" className="text-sm font-medium text-slate-700" data-id="element-93" data-mp="n22dnrnoksr">
                    Email Address
                  </label>
                  <input type="email" id="email" name="email" placeholder="you@example.com" autoComplete="off" className="w-full px-4 py-3 rounded-md border border-slate-300 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none transition-all" data-id="element-94" data-mp="3myh747kecc16" />
                </div>

                <div className="space-y-2" data-id="element-95" data-mp="2z71yjx210yhh">
                  <label htmlFor="message" className="text-sm font-medium text-slate-700" data-id="element-96" data-mp="2z60itfa2fntf">
                    Brief Description of Your Case
                  </label>
                  <textarea id="message" name="message" rows={4} placeholder="Tell us briefly about the diagnosis and exposure history…" autoComplete="off" className="w-full px-4 py-3 rounded-md border border-slate-300 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none transition-all resize-none" data-id="element-97" data-mp="1ap8sj355gnab"></textarea>
                </div>

                <button type="submit" disabled={isSubmitting} className="w-full bg-brand-accent hover:bg-brand-accentHover text-brand-900 font-bold text-lg py-4 rounded-md transition-all shadow-md hover:shadow-lg disabled:opacity-70 flex justify-center items-center gap-2" data-id="element-98" data-mp="vvxci8w6n6rx">
                  {isSubmitting ? 'Sending...' : 'Request Free Consultation'}
                </button>

                <p className="text-xs text-slate-500 text-center mt-4" data-id="element-99" data-mp="32oslr6ecv30y">
                  Information submitted is strictly confidential and does not
                  create an attorney-client relationship.
                </p>
              </form>}
          </div>
        </div>
      </div>
    </section>;
}